export enum BlogEnum {
    NEWS = 'NEWS',
    SMARTY = 'SMARTY'
}
